<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_auth(
          @click="onClickWrapper($event)"
        )
          .modal__close
            button.modal-button-close(
              @click="onCloseModal()"
            )
              img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            sign-in(
              v-if="modalType === 'sign_in'"
              @close="onCloseModal"
              @onChangeModalType="changeModalType"
            )
            sign-up(
              v-if="modalType === 'sign_up'"
              @close="onCloseModal"
              @onChangeModalType="changeModalType"
            )
            access-msg(
              v-if="modalType === 'access_msg'"
              @close="onCloseModal"
              :header-title="accessHeader.title"
              :header-text="accessHeader.text"
            )
            reset-password(
              v-if="modalType === 'reset_password'"
              @close="onCloseModal"
              @onChangeModalType="changeModalType"
            )
</template>

<script>
import {mapActions} from "vuex";
import jsMd5 from "js-md5";

import SignIn from "./components/SignIn.vue";
import SignUp from "./components/SignUp.vue";
import AccessMsg from "./components/AccessMsg.vue";
import ResetPassword from "./components/ResetPassword.vue";

export default {
  name: "authModal",
  components: {
    SignIn,
    SignUp,
    AccessMsg,
    ResetPassword
  },
  data() {
    return {
      modalType: "",
      accessHeader: {
        title: "",
        text: ""
      }
    };
  },
  computed: {
    registration_token() {
      return this.$route.query.registration_token;
    },
    reset_password_token() {
      return this.$route.query.reset_password_token;
    }
  },
  methods: {
    ...mapActions(["confirmRegistration", "getUser"]),
    onClickMask() {
      this.onCloseModal();
    },
    changeModalType(type, data) {
      this.modalType = type;
      if (type === "access_msg") {
        this.accessHeader.title = data.title;
        this.accessHeader.text = data.text;
      }
    },
    onClickWrapper(e) {
      // e.preventDefault();
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
      const query = Object.assign({}, this.$route.query);
      const queryIsEmpty = (function() {
        for (const key in query) {
          return false;
        }
        return true;
      }());
      if (!queryIsEmpty) {
        delete query.registration_token;
        delete query.reset_password_token;
        delete query.open_modal;
        this.$router.replace({query});
      }
    },
    onSubmitMethod(e) {
      e.preventDefault();
    }
  },
  mounted() {
    if (this.registration_token) {
      const minutes = ("0" + new Date().getMinutes()).slice(-2);
      const reverseMinutes = minutes
        .split("")
        .reverse()
        .join("");
      const xAuthHash = jsMd5(`${minutes}slozhno${reverseMinutes}`);
      this.confirmRegistration({
        data: {
          token: this.registration_token
        },
        xAuthHash
      }).then(res => {
        if (res.status === 200) {
          this.getUser();
          this.changeModalType("access_msg", {
            title: "Аккаунт подтвержден",
            text: "Теперь вы являетесь зарегистрированным пользователем"
          });
        }
      });
    } else if (this.reset_password_token) {
      this.modalType = "reset_password";
    } else {
      this.modalType = "sign_in";
    }
  }
};
</script>
